<!-- Title -->
<div class="text-center" *ngIf="page < 12">
    <h1>Module 2 - Managing Your Money</h1>
</div>

<!-- Module Content -->
<div id="module2">

    <section>
        <div *ngIf="page===1">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2>Managing Your Money</h2>
                <p><i>Serious problems are created when you rent a home you can’t afford. You may not be able to make the rent payments or may pay rent late so often that the landlord asks you to leave. In order to know how much you can afford for rent, you need
                            to
                            know how much money you have and what you spend. To make good spending decisions, you need to know the difference between things you need to buy and things you want to buy. It is also helpful to find ways to save money.</i></p>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" [routerLink]="'/RentWise'"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="5" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page===2">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2>Income and Expenses</h2>
                <p>In order to manage your money you need to know:</p>
                <ul class="bullet-points">
                    <li class="bullet-point">how much money you have (income)</li>
                    <li class="bullet-point">how much money you spend (expenses)</li>
                </ul>

                <h3>Planning Tips</h3>
                <ul class="bullet-points">
                    <li class="bullet-point">Develop a spending and savings plan using either the Estimating Monthly Income (Worksheet 1) and the Estimating Monthly Expenses and Estimating Monthly Expenses Summary (Worksheets 2 or 3) and/or the Making a Cash Flow Plan (Worksheet
                        4) in the pocket of the RentWise Organizer.</li>
                    <li class="bullet-point">Use only the dollar amount for all numbers. If the cents portion of the amount is less than 50 cents, drop the cents and record the dollar amount only. For example, $34.<b>25</b> would be recorded as $34. If the cents portion of the
                        amount is more than 50 cents, go up to the next dollar amount and record it. For example, $16.<b>95</b> would be recorded as $17.</li>
                    <li class="bullet-point">Unless you know what the amount is for sure, estimate income low and expenses high.</li>
                </ul>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">

                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="10" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>


            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page===3">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2>Buying on Credit</h2>
                <p>Sometimes you want to buy something that you do not have enough money to pay for. You may decide to buy it on credit. You might use a credit card or get credit through a store. Buying on credit and paying it back a little every month costs
                    you more.
                </p>
                <p>When you buy things on credit, remember:</p>
                <ul class="bullet-points">
                    <li class="bullet-point">you are actually borrowing money from the credit card company or store. They charge you a fee, called interest, to borrow that money.</li>
                    <li class="bullet-point">you pay back the cost of the item you bought PLUS the interest you are charged to borrow the money.</li>
                    <li class="bullet-point">when you pay a little every month, you are borrowing the money for a longer time so there is more interest to pay.</li>
                    <li class="bullet-point">items you buy on credit cost you a lot more in the long run unless you pay the bill off right away.</li>
                </ul>
                <h4>Questions to Ask Before Buying With Credit</h4>
                <ul class="bullet-points">
                    <li class="bullet-point">Do I really need this right now?</li>
                    <li class="bullet-point">Can I wait until I have saved enough money to buy it with cash or can I make a down payment on an installment loan?</li>
                    <li class="bullet-point">Is there a store selling this that offers a free layaway plan?</li>
                    <li class="bullet-point">Can I get credit from a store or borrow the money from a credit union, bank, or loan company?</li>
                    <li class="bullet-point">Would a used item from a classified ad or secondhand store work just as well?</li>
                </ul>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="20" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page===4">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2>Ways to Track Spending</h2>
                <p>Keep track of your spending so you become aware of your spending habits. This can help you make better financial decisions. Six ways to track spending are:</p>
                <ul class="bullet-points">
                    <li class="bullet-point"><b>Receipts</b> — Keep all sales receipts, cash register tapes, copies of money orders, and credit card slips in a folder or box.</li>
                    <li class="bullet-point"><b>Checkbook Register</b> — Use checks to pay for most expenses and describe all transactions in the checkbook. The check register helps you keep track of how much money is in a checking account. One of the most important things to
                        do is to record every transaction (check, deposit, withdrawal, service charge, debit card) in the check register. This method only works if every expense and its description are recorded.</li>
                    <li class="bullet-point"><b>Notebook or Ledger</b> — Use a notebook to track all expenses by date or use a ledger form to note expenses by category.</li>
                    <li class="bullet-point"><b>Calendar Method</b> — Make notes of income and expenses on a calendar.</li>
                    <li class="bullet-point"><b>Envelope Method</b> — On each payday, divide money into envelopes for various categories of expenses.</li>
                    <li class="bullet-point"><b>Cash Flow Plan</b> — Plan money by pay periods. Use the plan to also record income and expenses.</li>
                </ul>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="20" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page===5">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2>Reducing Expenses</h2>
                <h4>General</h4>
                <ul class="bullet-points">
                    <li class="bullet-point">Know the difference between things you need and things you want.</li>
                    <li class="bullet-point">Reduce monthly bills such as cable or telephone by eliminating special services, reducing long distance calls, and using phone cards.</li>
                    <li class="bullet-point">Use an allowance system with children rather than handing over money when asked.</li>
                    <li class="bullet-point">Hold family meetings to set saving or spending goals and to check progress toward goals.</li>
                    <li class="bullet-point">Avoid buying things on credit cards or credit plans. Items cost much more when paying interest on a credit card loan. Do not carry a balance on a credit card.</li>
                </ul>
                <h4>Housing</h4>
                <ul class="bullet-points">
                    <li class="bullet-point">Live with parents or other relatives.</li>
                    <li class="bullet-point">Share an apartment with a friend.</li>
                    <li class="bullet-point">Rent a small apartment and share a bedroom with your child or use a sofa sleeper in the living area.</li>
                    <li class="bullet-point">Reduce energy and water bills through more efficient use.</li>
                </ul>
                <h4>Food</h4>
                <ul class="bullet-points">
                    <li class="bullet-point">Use SNAP (Supplemental Nutrition Assistance Program), and limit other food purchases.</li>
                    <li class="bullet-point">Limit eating out and snack purchases.</li>
                    <li class="bullet-point">Use food pantries, commodities, and cheaper food products.</li>
                    <li class="bullet-point">Enroll children in school breakfast and lunch programs.</li>
                    <li class="bullet-point">Make a list before grocery shopping and only buy what is on the list.</li>
                    <li class="bullet-point">Buy items on sale that are needed.</li>
                    <li class="bullet-point">Buy in bulk when appropriate to needs. Compare unit costs.</li>
                </ul>
                <h4>Child Care</h4>
                <ul class="bullet-points">
                    <li class="bullet-point">Ask trusted relatives or friends to help with child care.</li>
                    <li class="bullet-point">Check if you are eligible for child-care subsidies.</li>
                    <li class="bullet-point">If you are a two-parent family, work opposite shifts.</li>
                    <li class="bullet-point">Trade child care with trusted relatives or friends when possible.</li>
                </ul>
                <h4>Clothing and Furniture</h4>
                <ul class="bullet-points">
                    <li class="bullet-point">Buy at used clothing and furniture stores and garage sales.</li>
                    <li class="bullet-point">Buy store brands. Buy only what you need.</li>
                    <li class="bullet-point">Buy items on sale. Watch for sale items following each season or after holidays.</li>
                </ul>
                <h4>Transportation</h4>
                <ul class="bullet-points">
                    <li class="bullet-point">Find a home close to your workplace so you can walk to work.</li>
                    <li class="bullet-point">Use the bus, if available, for most trips.</li>
                    <li class="bullet-point">Car pool or reduce commuting distance.</li>
                    <li class="bullet-point">Purchase a car that gets higher gas mileage (i.e., 25 to 30 mpg).</li>
                    <li class="bullet-point">Drive the car you own as long as possible, as long as it is in reasonable condition.</li>
                </ul>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="30" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page===6">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2>Plan for Change</h2>
                <p>Income and expenses change with time. Planning for change helps you to be ready and to make better decisions when changes happen.</p>
                <p>One common change is when you decide to move from one apartment to another. To help you make the best decision, use the Should I Move? Complete the activity below to help you decide whether to move to a different apartment or stay where
                    you are.</p>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="5" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section *ngIf="page===7">
        <div *ngVar="{
          downloaded: {'0':false, '1':false, '2':false, '3':false, '4':false},
          validate:   false
        } as content">
            <div class="container content-box module-content">
                <div class="text-center">
                    <h1>Activities</h1>
                </div>
                <hr>
                <h4>Instructions</h4>
                <ol class="numbered-list">
                    <li class="number">Download the activity handout by clicking the "Download Handout" button below</li>
                    <li class="number">Fill out the handout PDF on your computer, or print it to write your answers on paper</li>
                    <li class="number">Download the answer key by clicking the "Download Answer Key" button below and check your answers</li>
                </ol>

                <h4>Activity 1</h4>
                <p>For this activity you will estimate monthly income for Nancy, a single mother.</p>
                <div class="text-center">
                    <button type="button" class="btn waves-dark w-25" (click)="downloadHandoutFillablePdf1(); content.downloaded[0] = true" [class.invalid]="content.validate && !content.downloaded[0]">Download Handout</button>
                    <button type="button" class="btn waves-dark w-25" (click)="downloadKeyPdf1(); content.downloaded[1] = true" [class.invalid]="content.validate && !content.downloaded[1]">Download Answer Key</button>
                </div>

                <h4>Activity 2</h4>
                <p>Keep track of spending for a month. At the end of the month, total the amount spent for each spending category.</p>
                <div class="text-center">
                    <button type="button" class="btn waves-dark w-25" (click)="downloadHandoutFillablePdf2(); content.downloaded[2] = true" [class.invalid]="content.validate && !content.downloaded[2]">Download Handout</button>
                    <button type="button" class="btn waves-dark w-25" (click)="downloadKeyPdf2(); content.downloaded[3] = true" [class.invalid]="content.validate && !content.downloaded[3]">Download Answer Key</button>
                </div>

                <h4>Activity 3</h4>
                <p>Go through the checklist and classify items as essential, important, and unecessary. </p>
                <div class="text-center">
                    <button type="button" class="btn waves-dark w-25" (click)="downloadHandoutFillablePdf4(); content.downloaded[4] = true" [class.invalid]="content.validate && !content.downloaded[4]">Download Handout</button>
                </div>
            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <div class="invalid-feedback inline-summary text-right" *ngIf="content.validate && !allOf(content.downloaded)">Follow the above instructions to proceed.</div>
                <button type="button" class="btn waves-dark w-25" (click)="allOf(content.downloaded) ? next($event) : content.validate = true" [delay-click]="60" delay-tooltip="Finish reading through instructions and completing handouts first.">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page===8">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2>Energy Efficiency Measures to Manage Utility Bills and Increase Comfort</h2>
                <p><i>The following tips were designed to help you manage your energy costs and use energy wisely. Many of the ideas are low or no cost to help save energy with little out-of-pocket costs. The energy usage of each unit varies according to whether
                            it is a corner apartment or an inner apartment. The layout of the apartment complex can also affect energy usage. For example, corner units with windows on the north and west sides may be colder in the winter due to north and west winter
                            winds. Before renting your next apartment, ask about the utility rates for specific units and compare units in the complex if possible. Before doing any alterations to your rental unit, such as caulking and weather-stripping, get your
                            landlord’s permission or ask your landlord about having it done. All tenants pay for their utilities in one way or another. If your utilities are included in the rent, total rent costs may rise as the cost of utilities rise.</i></p>


                <h3>How Typical Homes Use Energy</h3>
                <p>The U.S. Department of Energy indicates that the typical home uses about 34 percent of their total energy for heating and about 11 percent for cooling. Refrigerators account for about 8 percent, while lighting, electronics, and other appliances
                    make up about 34 percent. Water heaters use about 13 percent of the total energy use in our homes.</p>

                <h4>Heating and Cooling</h4>
                <p>In the winter, set thermostats no higher than 72 degrees when people are home. Lower the thermostat when you sleep or are away. By turning your thermostat back 10 to 15 degrees for eight hours, you can save about 10 percent or more a year
                    on your heating bill.</p>
                <p>In fact, during the winter months, you can save about 1 percent on your heating bill for <b>every degree</b> you lower your thermostat over an eight-hour period. So, for example, by lowering your thermostat 5 degrees for <b>eight hours</b>,
                    your heating bill could drop by <b>5 percent or more.</b> During the winter, we recommend setting your thermostat to 65 degrees during the day and 55 degrees while you are away or sleeping.</p>
                <p>Contact the building manager or landlord if there is a heating problem. Do not use the stove for additional heat — it is dangerous. If it is too hot, talk to your landlord rather than open windows.</p>
                <p>Clean or replace your furnace filter(s) as directed by the manager or landlord and according to the use and care booklet.</p>
                <p><i>In the summer</i>, try to keep the thermostat set at 78 degrees. Turn the air conditioning control to higher temperatures when no one is home and when sleeping. Use overhead ceiling fans. Keep window shades or blinds down or closed.
                    In the evening and early morning, open windows if it is cooler or less humid outside. Air conditioners help to dehumidify. When air conditioners are turned off and humidity levels are high, mold problems can occur.</p>

                <h4>Windows and Doors</h4>
                <p>Use towels or buy an inexpensive door sweep to stop air coming in or going out under doors. If the door leaks around the entire frame, install foam weather stripping with adhesive backing between the door and the frame. Keep windows and
                    doors locked to get tighter seals. Ask the landlord about installing a layer of shrink-wrap plastic on the inside of windows.</p>
                <p>Use blinds or shades and lined curtains or draperies to reduce heat loss and gain through windows. Allow the sun’s heat in during the winter and keep it out during the summer.</p>

                <h4>Water</h4>
                <p>If you have a separate water heater set at 140 degrees, lower your water temperature to about 120 degrees (about midway between “low” and “medium” setting). This temperature should work for most purposes. Each 10 degrees reduction in water
                    temperature will generally save 3 percent to 5 percent on your water heating costs. If you leave for a trip, turn the water heater down further.Reduce shower time to lower energy use for heating water.</p>
                <p>Notify the building manager immediately of any water leaks. One drip can waste up to 48 gallons of water a week, waste energy from hot water, and can result in mold. Landlords may consider it a lease violation if they are not immediately
                    notified of a leak.</p>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="30" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page===9">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2>Energy Efficiency Measures to Manage Utility Bills and Increase Comfort</h2>
                <h3>How Typical Homes Use Energy Part 2</h3>
                <h4>Appliances and Lighting</h4>
                <ul class="bullet-points">
                    <h5>
                        <li class="bullet-point">Range and Oven</li>
                    </h5>
                    <p>Use pans that fit the burner to reduce heat lost. Use the broiler or microwave when possible. The broiler uses less energy and preheating is not required.</p>
                    <p>Use the kitchen exhaust fan when cooking to vent moisture and pollutants outdoors.</p>
                    <p>Don’t use the oven to heat your home. It can cause a fire hazard, and the fumes given off by a gas oven can increase carbon monoxide levels over time.</p>
                    <h5>
                        <li class="bullet-point">Refrigerator</li>
                    </h5>
                    <p>Refrigerators cost $5 to $8 per month to operate and use about 8 percent of the total energy used. Keep the refrigerator at 36 degrees to 38 degrees and the freezer at zero degrees.</p>
                    <p>The door should close firmly. Test for tightness by closing the door over a piece of paper or a dollar bill. You should feel a slight drag when you pull it out. If it is loose, ask about having the gasket replaced or the door adjustment
                        tightened. Keep the door open no longer than necessary.</p>
                    <p>Cool food slightly before putting it in the refrigerator so the refrigerator does not use as much energy.</p>
                    <p>Place refrigerators away from ovens. Do not place them in a hot garage or porch where they will have to work harder and use more energy to keep food cool.</p>
                    <h5>
                        <li class="bullet-point">Dishwasher</li>
                    </h5>
                    <p>Run the dishwasher only when it’s fully loaded. If available, use the energy-saving settings such as an energy-efficient drying cycle.</p>
                    <h5>
                        <li class="bullet-point">Washer and Dryer</li>
                    </h5>
                    <p>Only use hot water for very dirty clothes and items like diapers. Washing in hot water uses about 20 to 40 cents per load. Wash in warm and cold settings using cold water detergent. Refer to washing instructions on clothing labels
                        and on the washing machine.</p>
                    <p>Full loads of laundry in the washer save both energy and water. However, don’t overload it. Adjust water levels for smaller loads.</p>
                    <p>Clean the lint from the dryer’s filter after every load. Don’t overload. Overloaded dryers use more energy because items take longer to dry.</p>
                    <p>Look for the EnergyGuide labels and ENERGYSTAR® logo when buying new. More efficient units will save water and energy.</p>

                    <h5>
                        <li class="bullet-point">Air Conditioner</li>
                    </h5>
                    <p>Buy the correct size air conditioner for the square footage of your home. If the air conditioner is too large, it won’t operate efficiently and it will use more energy.</p>
                    <p>Window air conditioners have an energy efficiency rating — EER for short. Buy an air conditioner with an energy efficiency rating (EER) of at least 10. Look for the ENERGYSTAR and EnergyGuide labels. They may cost a little more but
                        will recapture that cost by using less electricity.</p>
                    <p>Remove or clean the filter every month according to instructions.</p>
                    <p>If possible, put a room air conditioner in a window that faces north or is shaded. Remove and store the air conditioner during the winter.</p>
                    <h5>
                        <li class="bullet-point">Small appliances and electronics</li>
                    </h5>
                    <p>Disconnect unneeded or unused equipment. Completely shut down computers, printers, TVs, radios, etc. when not in use. Automatic remote items use electricity unless they are turned completely off or unplugged. Unplug cell phone and
                        other chargers when not in use because they continue to use energy as long as they are plugged in.</p>
                    <h5>
                        <li class="bullet-point">Lighting costs</li>
                    </h5>
                    <p>Use screw-in compact fluorescent or LED light bulbs. Compact fluorescent and LED bulbs will cost less over time and will last longer than incandescent bulbs.</p>
                    <p>Turn off lights when rooms are not being used.</p>
                </ul>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="30" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page===10">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2>Energy Efficiency Measures to Manage Utility Bills and Increase Comfort</h2>
                <h3>How Typical Homes Use Energy Part 3</h3>
                <aside>
                    <h5>Did you know?</h5>
                    <p>1 standard bulb cost about $4.80/year to operate.</p>
                    <p>1 fluorescent bulb about $1.20/year to operate.</p>
                    <p>10 standard bulbs cost about $48.00/year.</p>
                    <p>10 fluorescent bulbs cost about $12.00/year.</p>
                </aside>

                <h4>Furniture and Bookcases</h4>
                <p>Place bookcases or large textile items on outer walls to reduce energy gain and loss through the walls. Check behind the items occasionally as condensation can sometimes create mildew or mold. Do not place furniture and curtains over or
                    around registers — it can change the air flow in your unit and can result in uneven heating and cooling.</p>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="10" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page===11">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2>Ask about Energy Assistance</h2>
                <p>Sometimes events happen that may create a need to seek help in addressing the home heating and cooling bills. Contact your local utility company to ask about any special programs if you get behind on utility payments. The level payment
                    plan allows you to pay an estimated amount each month. This evens out the payments and may make it easier for you to make monthly payments.</p>
                <p>The Nebraska Low Income Energy Assistance Program (LIHEAP) helps people with limited incomes offset the cost of heating and cooling their homes. The program will partially pay the cost of electricity, fuel oil, gas, coal, wood, kerosene,
                    propane, or other fuel source. If you have received a shutoff notice or a warning, you may be eligible for additional assistance. To be eligible for crisis assistance you must meet the resource and income guidelines, have attempted
                    to keep your utility bills current but unforeseen circumstances have created the crisis.</p>
                <p>Contact your Health and Human Service System or the Community Action Agency if you have questions about assistance for energy costs.</p>

                <div>
                    <h3>Ask your landlord about:</h3>
                    <ul class="bullet-points">
                        <li class="bullet-point">Installing programmable thermostats.</li>
                        <li class="bullet-point">Installing awnings, window shades or window films to block the summer sun.</li>
                        <li class="bullet-point">Caulking and weather-stripping windows and doors and sealing along the basement sill plate.</li>
                        <li class="bullet-point">Sealing air leaks around your windows and adding storm windows if needed.</li>
                        <li class="bullet-point">Fixing leaky faucets and toilets to conserve water.</li>
                        <li class="bullet-point">Using low‑flow showerheads and faucets.</li>
                        <li class="bullet-point">Adding insulation if needed. Insulating any crawlspace present.</li>
                        <li class="bullet-point">Sealing heating and cooling air duct seams with mastic or a UL 181 foil tape.</li>
                        <li class="bullet-point">Purchasing appliances and equipment that are high efficiency and meet the ENERGY STAR® minimum standard when replacement is necessary.</li>
                        <li class="bullet-point">Helping you find ways to lower energy usage in the rental unit.</li>
                    </ul>
                </div>

                <h3>Resources:</h3>
                <p>For information about weatherization assistance, contact:</p>
                <blockquote>
                    Nebraska Department of Environment and Energy<br> P.O. Box 95085<br> Lincoln, NE 68509-5085<br> Phone: (402) 471-2867<br> Fax: (402) 471-3064<br> Web site: www.dee.ne.gov/
                </blockquote>
                <p>The United States Department of Energy offers information on saving energy at the following Web sites:</p>
                <ul class="bullet-points">
                    <li class="bullet-point">ENERGY STAR — <a href="https://www.energystar.gov/">www.energystar.gov</a></li>
                    <li class="bullet-point">Energy Savers: Tips on Saving Money and Energy at Home — <a href="https://www.energy.gov/energysaver/tips-renters-and-rental-property-owners">energy.gov/energysaver/articles/tips-renters-and-property-owners</a></li>
                </ul>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next()">Quiz<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>
</div>

<section *ngIf="page===12">
    <app-quiz-questions [questions]="questions" [moduleNumber]="2" (quizSubmitted)="handleQuiz($event)"></app-quiz-questions>
</section>
